import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { BillingTransactionStatus } from "@/types/billing-transactions";

interface BillingTransactionStatusBadgeProps {
  status: BillingTransactionStatus;
}

const STATUS_LABEL_KEYS: Record<BillingTransactionStatus, string> = {
  [BillingTransactionStatus.PENDING]: "billing.pending",
  [BillingTransactionStatus.PROCESSING]: "billing.processing",
  [BillingTransactionStatus.SUCCEEDED]: "billing.succeeded",
  [BillingTransactionStatus.FAILED]: "billing.failed",
  [BillingTransactionStatus.CANCELED]: "billing.canceled",
  [BillingTransactionStatus.REFUNDED]: "billing.refunded",
  [BillingTransactionStatus.PARTIALLY_REFUNDED]: "billing.partiallyRefunded",
  [BillingTransactionStatus.REQUIRES_ACTION]: "billing.requiresAction",
  [BillingTransactionStatus.REQUIRES_PAYMENT_METHOD]:
    "billing.requiresPaymentMethod",
};

function getStatusVariant(status: BillingTransactionStatus) {
  switch (status) {
    case BillingTransactionStatus.PENDING:
      return "status_new" as const;
    case BillingTransactionStatus.PROCESSING:
    case BillingTransactionStatus.REQUIRES_ACTION:
    case BillingTransactionStatus.REQUIRES_PAYMENT_METHOD:
      return "status_in_progress" as const;
    case BillingTransactionStatus.SUCCEEDED:
      return "status_done" as const;
    case BillingTransactionStatus.REFUNDED:
    case BillingTransactionStatus.PARTIALLY_REFUNDED:
      return "status_approved" as const;
    case BillingTransactionStatus.FAILED:
    case BillingTransactionStatus.CANCELED:
      return "status_canceled" as const;
  }
}

export const BillingTransactionStatusBadge: React.FC<
  BillingTransactionStatusBadgeProps
> = ({ status }) => {
  const { t } = useTranslation();

  return (
    <Badge variant={getStatusVariant(status)}>
      {t(STATUS_LABEL_KEYS[status])}
    </Badge>
  );
};
